export function isEmpty(input: string): boolean {
  return !input || input.length === 0;
}
